import {
  withCompInfo,
  createComponentMapperModel,
} from '@wix/editor-elements-integrations';
import type { SubmenuDefinition, SubmenuCarmiProps } from '../types';
import { hasDetachedStyleProperties } from '../../Menu/editor/AttachStyles/utils';

export const props = withCompInfo<{}, SubmenuDefinition, SubmenuCarmiProps>()(
  [],
  (_, carmiData) => carmiData,
);

export const css = withCompInfo<{}, SubmenuDefinition, SubmenuCarmiProps>()(
  ['compData', 'styleProperties'],
  ({ compData, styleProperties }) => {
    const { direction } = compData;
    const isDetached = hasDetachedStyleProperties(styleProperties);

    return {
      '--direction': isDetached ? direction : 'initial',
    };
  },
);

export default createComponentMapperModel({ props, css });
